import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import {
  currentSelectedNetwork,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { PEER_APPROVED_TYPE } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
import {
  changeStatusReasonForEditCrqId,
  clearEditSectionsRead,
  fetchRemedyRefCrqForViewRequest,
  fetchRemedyRefCrqForSuccess,
  fetchRemedyRefCrqForError,
  clearRemedyRefCrqForError,
  clearRelatedCoordinatorID,
  clearAdjacentRemedyRefFromFormData,
} from 'AppSrc/core/actions/actions-edit-form';
import {
  updateEditCrqWithId,
  updateEditCrqWithIdChangeAnalyst,
  updateRemedyRefCrqWithId,
} from 'AppSrc/core/actions/actions-update-edit-form';
import { getWiiMetadata } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-logic';
import { submitAndUpdateCreateCrqFormVINE } from 'AppSrc/core/actions/actions-create-crq-form';
import { flAddApproverGroupsToCrq } from 'AppSrc/core/crq/crq-list-actions';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
import { Alert } from 'AppSrc/core/components/utility/alert';
import { withRouter } from 'react-router';
import { CRQ_STATUSES } from 'AppSrc/core/crq/crq-statuses';
import {
  getFowardTransition,
  getBackwardTransition,
  CRQ_STATUS_TRANSITIONS,
} from 'AppSrc/core/crq/crq-status-transitions';
import { Loader } from 'AppSrc/core/components/utility/loader';
import { SubmitCreateCrqProgress } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/submit-create-crq-progress';
import { getFailedToSubmitAlertData } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/section-change-request-utils';
import { CancelCrqModal } from './modals/cancel-crq-modal';
import { RejectCrqModal } from './modals/reject-crq-modal';
import { ApprovalModal } from './modals/approval-modal';
import { ApprovalRejectModal } from './modals/approval-reject-modal';
import { getDefaultCancelationReasonEmergency } from '../../crq/crq-status-reasons';
// import { PostponeAlertModal } from './modals/reschedule-crq-model';


const cancelModalMap = {
  [CRQ_STATUSES.coordinator]: CancelCrqModal,
  [CRQ_STATUSES.peerReview]: RejectCrqModal,
  [CRQ_STATUSES.approvals]: ApprovalRejectModal,
};

const getCancelModal = (status) => {
  const CancelModal = cancelModalMap[status];

  if (!CancelModal) {
    console.error(`Unable to provide a cancel modal with status: ${status}`);
    return () => null;
  }

  return CancelModal;
};

const submitModalMap = {
  [CRQ_STATUSES.approvals]: ApprovalModal,
};

const getSubmitModal = (status, submitModalOpen) => {
  if (!submitModalOpen) {
    return null;
  }

  const SubmitModal = submitModalMap[status];

  if (!SubmitModal) {
    // If you see this error, it might literally be because a modal isn’t needed for this status
    console.error(`Unable to provide a submit modal with status: ${status}.`);
    return () => null;
  }

  return SubmitModal;
};



const leftButtonText = {
  [CRQ_STATUSES.coordinator]: 'Cancel CRQ',
  [CRQ_STATUSES.peerReview]: 'Reject CRQ',
  [CRQ_STATUSES.approvals]: 'Reject CRQ',
};

const rightButtonText = {
  [CRQ_STATUSES.coordinator]: 'Submit',
  [CRQ_STATUSES.peerReview]: 'Approve',
  [CRQ_STATUSES.approvals]: 'Approve',
};

const rightButtonDataTooltipText = {
  [CRQ_STATUSES.coordinator]: 'Please expand and review all the sections to enable the submit button',
  [CRQ_STATUSES.peerReview]: 'Please expand and review all the sections to enable the approve button',
  [CRQ_STATUSES.approvals]: 'Please expand and review all the sections to enable the approve button',
};

const getHandleSubmit = ({
  status,
  setSubmitModalOpen,
  setConfirmSubmitOpen,
  // ispostponeReason1,
  // ispostponeReason2,
  // ispostponeReason3,
  // setPostponeAlertModalOpen,
  otherLineOperator,
}) => {
  // if (ispostponeReason1 && ispostponeReason2 && ispostponeReason3) {
  //   return () => setPostponeAlertModalOpen(true);
  // }
  if (status === CRQ_STATUSES.approvals) {
    return () => setSubmitModalOpen(true);
  }
  return () => setConfirmSubmitOpen(true);
};

// Create 2nd flag for Emergency 2d Journey
const hasEmergenctL3Approvalwii = (formData, network) => {
  if (!formData) { return false; }
  const wiis = getWiiMetadata(formData);
  const approvalType = PEER_APPROVED_TYPE[network];
  return wiis.some((wii) => wii.type === approvalType);
};

const getProceedAlertData = (status, isOlaCrq, hasReferenceCRQ, network, isEmergencyCrq, isEmergency2ndJourney) => {

  const alertDataForStatusMap = {
    [CRQ_STATUSES.coordinator]: {
      alertTitle: (isOlaCrq === true || (network === 'mobile' && hasReferenceCRQ() === true) || isEmergency2ndJourney) ? 'Are you sure you want to submit to Approvals?' : `Are you sure you want to submit this CRQ for ${(isEmergencyCrq && !isEmergency2ndJourney) ? 'L3 Approval' : 'peer review'} ?`,
      alertText: 'Please ensure you have provided/checked the required information/documentation to support your change request to avoid any delays.',
      falseText: 'Back',
      trueText: 'Yes, submit',
    },
    [CRQ_STATUSES.peerReview]: {
      alertTitle: 'Are you sure you want to approve this CRQ?',
      falseText: 'Back',
      trueText: 'Yes, approve',
    },
  };
  const alertData = alertDataForStatusMap[status];

  if (!alertData) {
    console.warn(`Could not find alert data for status ${status}`);
    return ({
      alertTitle: 'Are you sure you want to advance',
      falseText: 'Back',
      trueText: 'Yes, advance',
    });
  }
  return alertData;

};

const ViewCrqNavDisplay = ({
  network,
  canSubmit,
  rejectToPrevStatus,
  submitToNextStep,
  status,
  statusReason,
  crqId,
  // assign,
  isChangeAnalyst,
  changeAnalystCircuitCheckID, // adding for graying out the button
  userLoggedIn, // adding for graying out the button
  flAddApproverAPI,
  slaCancelModal, // for dealing view-crq-nav while performing crq-actions in approval stage.
  slaPostponeModal, // for dealing view-crq-nav while performing crq-actions in approval stage.
  // postponeReason1,
  // postponeReason2,
  // postponeReason3,
  otherLineOperator,
  isMobileYesFlag,
  serImpAssRemedyFlagAtCR,
  hasReferenceCRQ,
  isSubmittingRef,
  haserrorRef,
  remedyRefFormData,
  formData,
  isCrqInfo,
  isEmergencyCrq,
}) => {
  // const COMM_SLA_MISSED_MESSAGE = 'SLA Missed';
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [confirmSubmitOpen, setConfirmSubmitOpen] = useState(false);
  // Most of the time we just want to confirmSubmit. But sometimes we want to do
  // extra steps. In which case we use a modal
  const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const [hasErrorRefFlag, sethasErrorRefFlag] = useState(false);
  useEffect(() => {
    if (haserrorRef !== '') {
      sethasErrorRefFlag(true);
    }
    // eslint-disable-next-line
  }, [haserrorRef]);
  // const [ispostponeReason1] = useState((postponeReason1 && postponeReason1 !== '') ? true : false);
  // const [ispostponeReason2] = useState((postponeReason2 && postponeReason2 !== '') ? true : false);
  // const [ispostponeReason3] = useState((postponeReason3 && postponeReason3 !== '') ? true : false);
  const handleSubmit = getHandleSubmit({
    status,
    setSubmitModalOpen,
    setConfirmSubmitOpen,
    // ispostponeReason1,
    // ispostponeReason2,
    // ispostponeReason3,
    // setPostponeAlertModalOpen,
  });
  // If related ref CRQ has been rejcted or postponed or cancelled and their statuses not beyond circuit check then disable coord submit button
  if (hasReferenceCRQ() === true && remedyRefFormData.network === 'fixed' && canSubmit === true && ((remedyRefFormData.status === '1') || (remedyRefFormData.status === '2') || (remedyRefFormData.status === '3') || (remedyRefFormData.status === '4') || (remedyRefFormData.status === '12'))) {
    canSubmit = !canSubmit;
  }

  if (status === CRQ_STATUSES.approvals) {
    const {
      approvalHistory,
    } = formData;

    const hasDoneApprovals = approvalHistory && approvalHistory.map((eachItems) => {
      const isApprovalsCompleted = ((eachItems.status === 'Pending') && (eachItems.type === 'Approvals') && (eachItems.actionable === true));
      return isApprovalsCompleted;
    });
    // if it has atleast one true then button should be normal either false
    const hasPendingApprovals = hasDoneApprovals.some((eachApproval) => eachApproval === true);
    canSubmit = hasPendingApprovals ? canSubmit : false;
  }

  const isEmergency2ndJourney2 = hasEmergenctL3Approvalwii(formData, network);
  const submit = (submitConfirmed) => {
    if (submitConfirmed.boolean) {
      submitToNextStep(network, statusReason, isMobileYesFlag, hasReferenceCRQ, formData, isEmergencyCrq, isEmergency2ndJourney2);
    }
    setConfirmSubmitOpen(false);
    window.localStorage.removeItem('isInfoItem');
  };

  // left/right buttonText should always be truthy, but we should fall back to generic if falsy
  const leftText = leftButtonText[status] ? leftButtonText[status] : 'Back';
  const rightText = rightButtonText[status] ? rightButtonText[status] : 'Next';
  let abc = false;
  if (statusReason === '10500') {
    window.sessionStorage.setItem('vineCheckPoint', isMobileYesFlag);
    abc = true;
  }
  const rightTextTooltip = (isCrqInfo && !abc && !canSubmit && rightButtonDataTooltipText[status]) ? rightButtonDataTooltipText[status] : '';
  // since we are not sending status reason while creating crq, so we are using localstorage to fetch statusreason.
  window.sessionStorage.setItem('statusReason', statusReason);
  window.sessionStorage.setItem('status', status);

  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  // const isOlaCrq = otherLineOperator || isOloByService;
  const isOlaCrq = isOloByService;
  const CancelModal = getCancelModal(status);
  const SubmitModal = getSubmitModal(status, submitModalOpen);
  const proceedAlertData = getProceedAlertData(status, isOlaCrq, hasReferenceCRQ, network, isEmergencyCrq, isEmergency2ndJourney2);
  const failedToSubmitAlertData = getFailedToSubmitAlertData(crqId);
  // for dealing view-crq-nav while performing crq-actions in approval stage.
  if (slaCancelModal || slaPostponeModal) {
    return null;
  }

  // When Remedy ref create, update loader and error alert need this
  const loaderArray = [true, false];
  const alertData = loaderArray.length > 0 ? ({
    option: null,
    alertTitle: 'An unexpected error has occurred to related crq',
    alertText: 'Please refresh the page and try again',
    falseText: 'Close',
    trueText: 'Refresh',
  }) : null;
  // Modal error alert click action
  const handleErrorConfirmationRef = (elm) => {
    if (elm.boolean === true) {
      window.location.reload();
    }
    else {
      sethasErrorRefFlag(false);
    }
  };

  return (
    <>
      {/* When we do a stick to bottum situation we will probably need this. It's too difficult to implement now though */}
      <div className="form-nav-section form-nav-section-spacemaker" />
      <div className="form-nav-section">
        <div className="side-left">
          <button
            disabled={(((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || isEmergencyCrq || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) && isChangeAnalyst === true && statusReason === '10500') || (network === 'mobile' && (status === 'Planning In Progress' || status === '3') && hasReferenceCRQ() === true && ((remedyRefFormData.status !== '5' || remedyRefFormData.status !== 'Scheduled For Approval') && (remedyRefFormData.status !== '6' || remedyRefFormData.status !== 'Scheduled')) && remedyRefFormData.adjacent_remedy_ref !== undefined) ? true : false}
            type="button"
            className={(((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || isEmergencyCrq || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) && isChangeAnalyst === true && statusReason === '10500') || (network === 'mobile' && (status === 'Planning In Progress' || status === '3') && hasReferenceCRQ() === true && ((remedyRefFormData.status !== '5' || remedyRefFormData.status !== 'Scheduled For Approval') && (remedyRefFormData.status !== '6' || remedyRefFormData.status !== 'Scheduled')) && remedyRefFormData.adjacent_remedy_ref !== undefined) ? 'submit-button-not-ready' : 'cancel-button'}
            onClick={() => setCancelModalOpen(true)}
          >
            {leftText}
          </button>
        </div>
        <div className="side-right">
          <button
            type="button"
            disabled={!canSubmit}
            className={`submit-button${canSubmit ? '' : '-not-ready'}`}
            // className="submit-button"
            data-tip={rightTextTooltip}
            onClick={handleSubmit}
          >
            { abc ? 'Submit' : [rightText] }
          </button>
          <ReactTooltip />
        </div>
      </div>
      {
        confirmSubmitOpen && (
          <Alert
            alertData={proceedAlertData}
            resolveAlert={submit}
          />
        )
      }
      {
        confirmSubmitOpen && (
          <Alert
            alertData={proceedAlertData}
            resolveAlert={submit}
          />
        )
      }
      {
        submitModalOpen && (
          <SubmitModal
            closeModal={() => setSubmitModalOpen(false)}
            network={network}
            rejectToPrevStatus={rejectToPrevStatus}
            statusReason={statusReason ? statusReason : ''}
            crqId={crqId}
          />
        )
      }
      {
        cancelModalOpen && (
          <CancelModal
            closeModal={() => setCancelModalOpen(false)}
            network={network}
            rejectToPrevStatus={rejectToPrevStatus}
            crqId={crqId}
            statusReason={statusReason ? statusReason : ''}
          />
        )
      }
      {/* {postponeAlertModalOpen && (
        <PostponeAlertModal
          closeModal={() => setPostponeAlertModalOpen(false)}
        />
      )} */}
      <SubmitCreateCrqProgress
        editCrqId={crqId}
        // custon alert data for if the submit fails
        errorAlertData={failedToSubmitAlertData}
      />
      {
        isSubmittingRef && (
          <Loader
            loaderArray={loaderArray}
            loaderTitle="Please wait whilst we update your CRQ"
            loaderText="Do not close or refresh your browser whilst we do this."
          />
        )
      }
      {
        hasErrorRefFlag && (
          <Alert
            alertData={alertData}
            resolveAlert={handleErrorConfirmationRef}
          />
        )
      }
    </>
  );
};

ViewCrqNavDisplay.propTypes = {
  network: PropTypes.string,
  canSubmit: PropTypes.bool,
  rejectToPrevStatus: PropTypes.func,
  submitToNextStep: PropTypes.func,
  status: PropTypes.string,
  statusReason: PropTypes.string,
  crqId: PropTypes.string,
  // assign: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool,
  userLoggedIn: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  flAddApproverAPI: PropTypes.func,
  slaCancelModal: PropTypes.bool,
  slaPostponeModal: PropTypes.bool,
  // postponeReason1: PropTypes.string,
  // postponeReason2: PropTypes.string,
  // postponeReason3: PropTypes.string,
  otherLineOperator: PropTypes.string,
  isMobileYesFlag: PropTypes.string,
  serImpAssRemedyFlagAtCR: PropTypes.bool,
  hasReferenceCRQ: PropTypes.func,
  isSubmittingRef: PropTypes.bool,
  haserrorRef: PropTypes.string,
  remedyRefFormData: PropTypes.objectOf(PropTypes.string),
  formData: PropTypes.objectOf(PropTypes.string),
  isCrqInfo: PropTypes.bool,
  isEmergencyCrq: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { crqId } = ownProps;
  const formData = state.editForm.formDataById[crqId];
  const isSubmittingRef = state.remedyReferenceCrq.fetching;
  const haserrorRef = state.remedyReferenceCrq.error;
  const network = formData ? currentSelectedNetwork(formData) : null;
  return {
    network, isSubmittingRef, haserrorRef, formData,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  rejectToPrevStatus(network) {
    const {
      crqId,
    } = ownProps;
    const statusTransition = getBackwardTransition({ currentStatus: ownProps.status });
    dispatch(updateEditCrqWithId(crqId, statusTransition))
      // .then(() => {
      //   dispatch(updateEditCrqWithId(crqId, statusTransition));
      // })
      .then(() => {
        dispatch(clearEditSectionsRead(crqId));
        // navigate to the success route, with the correct crqId
        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
          network,
          crqId,
          transitionId: statusTransition.id,
        });
        ownProps.history.push(successPath);
      })
      .catch((error) => {
        console.error(error);
        // TODO add error alert
      });
    return null;
  },
  submitToNextStep(network, statusReason, isMobileYesFlag, hasReferenceCRQ, formData, isEmergencyCrq, isEmergency2ndJourney2) {
    const {
      crqId,
      status,
      isChangeAnalyst,
    } = ownProps;
    const statusTransition = getFowardTransition({ currentStatus: ownProps.status, formData });
    const checkImpact = window.localStorage.getItem('impacts');
    const checkNetwork = window.localStorage.getItem('networks');

    const changeDetails = 'CHANGE_DETAILS';
    const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
    const isOlaCrq = isOloByService;
    const isEmergency = isEmergencyCrq;
    const isEmergency2ndJourney = isEmergency2ndJourney2;
    console.log('circuit check submit1', isChangeAnalyst);
    if (checkNetwork === 'fixed' && (checkImpact === '1' || checkImpact === '2') && status === '4') {
      if (statusReason === '10500' || (isEmergency && isEmergency2ndJourney)) {
        // When user click Yes VINE Creation and updation process via this condition
        if (isMobileYesFlag === 'Yes') {
          // When Current fixed has reference crq then we can reuse current mobile cancelled to planning in progress and update
          if (hasReferenceCRQ() === true) {
            // Update - reuse Related mobile CRQ
            const remedyRefStatus = 'Planning In Progress';
            const remedyRefStatusReason = null;
            dispatch(fetchRemedyRefCrqForViewRequest());
            dispatch(updateRemedyRefCrqWithId(crqId, remedyRefStatus, remedyRefStatusReason))
              .then((responseMobile) => {
                window.sessionStorage.setItem('relatedCRQId', responseMobile.id);
                dispatch(fetchRemedyRefCrqForSuccess());
                dispatch(clearRemedyRefCrqForError());
                // Action call after mobile VINE created - here we resuing mobile cancel crq
                dispatch(flAddApproverGroupsToCrq(network, crqId))
                  .then((response) => {
                    if (response === 200) {
                      dispatch(updateEditCrqWithIdChangeAnalyst(crqId))
                        .then(() => {
                          dispatch(changeStatusReasonForEditCrqId({
                            crqId,
                            statusReason: (status === '3') ? null : statusReason,
                          }));
                          dispatch(updateEditCrqWithId(crqId, statusTransition));
                        })
                        .then(() => {
                          dispatch(clearEditSectionsRead(crqId));
                          dispatch(clearRelatedCoordinatorID());
                          // navigate to the success route, with the correct crqId
                          let NewstatusTransition = statusTransition;
                          if (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) {
                            NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                          }
                          const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                            network,
                            crqId,
                            transitionId: NewstatusTransition.id,
                          });
                          ownProps.history.push(successPath);
                        })
                        .catch((error) => {
                          console.error(error);
                          // TODO add error alert
                        });
                    }
                  });
              })
              .catch((error) => {
                console.error(error);
                fetchRemedyRefCrqForError(error);
                return Promise.reject(error);
              });
          }
          else {
            // Create Related mobile CRQ
            dispatch(fetchRemedyRefCrqForViewRequest());
            dispatch(submitAndUpdateCreateCrqFormVINE(CRQ_STATUS_TRANSITIONS.raiseCrq, crqId))
              .then((responseMobile) => {
                window.sessionStorage.setItem('relatedCRQId', responseMobile);
                dispatch(fetchRemedyRefCrqForSuccess());
                dispatch(clearRemedyRefCrqForError());
                // Action call after mobile VINE created
                dispatch(flAddApproverGroupsToCrq(network, crqId))
                  .then((response) => {
                    if (response === 200) {
                      dispatch(updateEditCrqWithIdChangeAnalyst(crqId))
                        .then(() => {
                          dispatch(changeStatusReasonForEditCrqId({
                            crqId,
                            statusReason: (status === '3') ? null : statusReason,
                          }));
                          dispatch(updateEditCrqWithId(crqId, statusTransition));
                        })
                        .then(() => {
                          dispatch(clearEditSectionsRead(crqId));
                          dispatch(clearRelatedCoordinatorID());
                          // navigate to the success route, with the correct crqId
                          let NewstatusTransition = statusTransition;
                          if (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) {
                            NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                          }
                          const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                            network,
                            crqId,
                            transitionId: NewstatusTransition.id,
                          });
                          ownProps.history.push(successPath);
                        })
                        .catch((error) => {
                          console.error(error);
                          // TODO add error alert
                        });
                    }
                  });
              })
              .catch((error) => {
                console.error(error);
                fetchRemedyRefCrqForError(error);
                return Promise.reject(error);
              });
          }
        }
        else {
          if (isMobileYesFlag === 'No' && hasReferenceCRQ() === true) {
            const remedyRefStatus = 'Cancelled';
            const remedyRefStatusReason = 'No Longer Required';
            // const postponeAdjReason1 = 'Your adjacent Fixed Crq has been postponed';
            dispatch(clearAdjacentRemedyRefFromFormData(crqId));
            dispatch(updateRemedyRefCrqWithId(crqId, remedyRefStatus, remedyRefStatusReason))
              .catch((error) => {
                console.error(error);
                fetchRemedyRefCrqForError(error);
                return Promise.reject(error);
              });
          }
          dispatch(flAddApproverGroupsToCrq(network, crqId))
            .then((response) => {
              // Circuit check emeregency logic goes here if else
              if (response === 200) {
                dispatch(updateEditCrqWithIdChangeAnalyst(crqId))
                  .then(() => {
                    dispatch(changeStatusReasonForEditCrqId({
                      crqId,
                      statusReason: (status === '3') ? null : statusReason,
                    }));
                    dispatch(updateEditCrqWithId(crqId, statusTransition));
                  })
                  .then(() => {
                    dispatch(clearEditSectionsRead(crqId));
                    // navigate to the success route, with the correct crqId
                    let NewstatusTransition = statusTransition;
                    if (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) {
                      NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                    }
                    const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                      network,
                      crqId,
                      transitionId: NewstatusTransition.id,
                    });
                    ownProps.history.push(successPath);
                  })
                  .catch((error) => {
                    console.error(error);
                    // TODO add error alert
                  });
              }
            });
        }
      }
      else {
        // peer review before Circuit check stage Emergency call on stage 4 to stage 3
        /* eslint-disable */
        // if (isEmergency && !isEmergency2ndJourney) {
        //   // Emergency 1st Journey on status 4
        //   const statusTransitionEmergency = getBackwardTransition({ currentStatus: '3' });
        //   const selectedReasonEmergency = getDefaultCancelationReasonEmergency(network);
        //   console.log('abcwii inner check0 EMGC vine update new>>>', statusTransition, statusTransitionEmergency, selectedReasonEmergency);
        //   dispatch(clearEditSectionsRead(crqId));
        //   // approved by peer
        //   dispatch(updateEditCrqWithId(crqId, statusTransition))
        //   .then((response) => {
        //     // console.log('inner check0 EMGC vine update new>>>', response, response.success === true);
        //     console.log('abcwii 2');
        //     if (response.success === true) {
        //       dispatch(clearEditSectionsRead(crqId));
        //       console.log('abc cancel');
        //       return dispatch(updateEditCrqWithId(crqId, statusTransitionEmergency, selectedReasonEmergency))
        //         .then(() => {
        //           const statusTransitionPostponeEmergency = getBackwardTransition({ currentStatus: '4', isEmergency });
        //           const selectedReasonPostponeEmergency = network === 'fixed' ? '30300' : 'PostponedCRQ';
        //          //  console.log('inner check0 EMGC vine update new>>>', statusTransitionPostponeEmergency, selectedReasonPostponeEmergency);
        //          console.log('abc post');
        //           dispatch(updateEditCrqWithId(crqId, statusTransitionPostponeEmergency, selectedReasonPostponeEmergency))
        //             .then(() => {
        //               dispatch(clearEditSectionsRead(crqId));
        //               dispatch(clearRelatedCoordinatorID());
        //               console.log('inner check01 EMGC vine update new>>>');
        //             })
        //             .then(() => {
        //               dispatch(clearEditSectionsRead(crqId));
        //               let NewstatusTransition = statusTransition;
        //               console.log('inner check6>>>');
        //               if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true)) {
        //                 NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
        //               }
        //               const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
        //                 network,
        //                 crqId,
        //                 transitionId: NewstatusTransition.id,
        //               });
        //               ownProps.history.push(successPath);
        //             })
        //             .catch((error) => {
        //               console.error(error);
        //               // TODO add error alert
        //               return Promise.reject(error);
        //             });
        //         })
        //         .catch((error) => {
        //           console.error(error);
        //           return Promise.reject(error);
        //         });
        //     }
        //   })
        //   .catch((error) => {
        //     console.error(error);
        //     return Promise.reject(error);
        //   });
        // }
        if (isEmergency && !isEmergency2ndJourney) {
          // Emergency 1st Journey on status 4
          const statusTransitionEmergency = getBackwardTransition({ currentStatus: '3' });
          const selectedReasonEmergency = getDefaultCancelationReasonEmergency(network);
          dispatch(clearEditSectionsRead(crqId));
          
          // approved by peer
          dispatch(updateEditCrqWithId(crqId, statusTransition))
            .then((response) => {
              if (response.success === true) {
                dispatch(clearEditSectionsRead(crqId));
                setTimeout(() => {
                  // Cancellation API call fo Journey 1 status 4 to 3
                  dispatch(updateEditCrqWithId(crqId, statusTransitionEmergency, selectedReasonEmergency))
                    .then((response) => {
                      if (response && response.success === true) {
                        const statusTransitionPostponeEmergency = getBackwardTransition({ currentStatus: '4', isEmergency });
                        const selectedReasonPostponeEmergency = network === 'fixed' ? '30300' : 'PostponedCRQ';
                        // Postoned API call fo Journey 1 status 4 to 3
                        return dispatch(updateEditCrqWithId(crqId, statusTransitionPostponeEmergency, selectedReasonPostponeEmergency));
                      }
                    })
                    .then((response) => {
                      if (response && response.success === true) {
                        dispatch(clearEditSectionsRead(crqId));
                        dispatch(clearRelatedCoordinatorID());
                        
                        let NewstatusTransition = statusTransition;
                        if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true)) {
                          NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                        }
                        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                          network,
                          crqId,
                          transitionId: NewstatusTransition.id,
                        });
                        ownProps.history.push(successPath);
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                      // TODO add error alert
                      return Promise.reject(error);
                    });
                }, 3000); // 3 seconds delay
              }
            })
            .catch((error) => {
              console.error(error);
              // TODO add error alert
              return Promise.reject(error);
            });
        }
        else {
          const nomalStatus = '3';
          dispatch(updateEditCrqWithIdChangeAnalyst(crqId))
            .then(() => {
              dispatch(changeStatusReasonForEditCrqId({
                crqId,
                statusReason: (status === nomalStatus) ? null : statusReason,
              }));
              dispatch(updateEditCrqWithId(crqId, statusTransition));
            })
            .then(() => {
              dispatch(clearEditSectionsRead(crqId));
              // navigate to the success route, with the correct crqId
              let NewstatusTransition = statusTransition;
              if (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) {
                NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
              }
              const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                network,
                crqId,
                transitionId: NewstatusTransition.id,
              });
              ownProps.history.push(successPath);
            })
            .catch((error) => {
              console.error(error);
              // TODO add error alert
            });
        }
      }
    }
    else {
      // const isEmergency2ndJourney = false;

      // For EMGC submit call *************************************
      if (isEmergency) {
        if (isEmergency2ndJourney && (status === '3' || status === 'Planning In Progress' || (status === '3' && (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true)))) {
          // Emergency 2nd Journey----
          // Emergency 2nd Journey on status 3
          dispatch(changeStatusReasonForEditCrqId({
            crqId,
            statusReason: null,
          }));
          // EMGC 2nd Journey -> coordinator to circuit check stage for impact 1&2
          if ((checkImpact === '1' || checkImpact === '2') && network === 'fixed' && !isOlaCrq) {
            let peerStatusTransition = getFowardTransition({ currentStatus: '3', formData, isEmergency });
            dispatch(updateEditCrqWithId(crqId, peerStatusTransition, '10500'))
              .then(() => {
                dispatch(clearEditSectionsRead(crqId));
                if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true) || network === 'fixed') {
                  peerStatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                }
                const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                  network,
                  crqId,
                  transitionId: peerStatusTransition.id,
                });
                ownProps.history.push(successPath);
              })
              .catch((error) => {
                console.error(error);
                // TODO add error alert
              });
          }
          else {
            const peerStatusTransition = getFowardTransition({ currentStatus: '3', formData, isEmergency });
            let NewstatusTransition = getFowardTransition({ currentStatus: '5', formData, isEmergency, isEmergency2ndJourney });
            dispatch(updateEditCrqWithId(crqId, peerStatusTransition))
              .then(() => {
                dispatch(clearEditSectionsRead(crqId));
                dispatch(updateEditCrqWithId(crqId, NewstatusTransition));
                if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true) || network === 'fixed') {
                  NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                }
                const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                  network,
                  crqId,
                  transitionId: NewstatusTransition.id,
                });
                ownProps.history.push(successPath);
              })
              .catch((error) => {
                console.error(error);
                // TODO add error alert
              });
          }
        }
        else if (isEmergency2ndJourney === false && (status === '4' || status === 'Scheduled For Review') || (status === '4' && (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true))) {
          // Emergency 1st Journey----
          // Emergency 1st Journey on status 4
          const statusTransitionEmergency = getBackwardTransition({ currentStatus: '3' });
          const selectedReasonEmergency = getDefaultCancelationReasonEmergency(network);
          // Approved by peer API call
          dispatch(updateEditCrqWithId(crqId, statusTransition))
            .then((response) => {
              if (response.success === true) {
                dispatch(clearEditSectionsRead(crqId));
                setTimeout(() => {
                  // Cancellation API call fo Journey 1 status 4 to 3
                  dispatch(updateEditCrqWithId(crqId, statusTransitionEmergency, selectedReasonEmergency))
                    .then((response) => {
                      if (response && response.success === true) {
                        const statusTransitionPostponeEmergency = getBackwardTransition({ currentStatus: '4', isEmergency });
                        const selectedReasonPostponeEmergency = network === 'fixed' ? '30300' : 'PostponedCRQ';
                        // Postoned API call fo Journey 1 status 4 to 3
                        return dispatch(updateEditCrqWithId(crqId, statusTransitionPostponeEmergency, selectedReasonPostponeEmergency));
                      }
                    })
                    .then((response) => {
                      if (response && response.success === true) {
                        dispatch(clearEditSectionsRead(crqId));
                        dispatch(clearRelatedCoordinatorID());
                        
                        let NewstatusTransition = statusTransition;
                        if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true)) {
                          NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                        }
                        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                          network,
                          crqId,
                          transitionId: NewstatusTransition.id,
                        });
                        ownProps.history.push(successPath);
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                      // TODO add error alert
                      return Promise.reject(error);
                    });
                }, 3000); // 1 seconds delay
              }
            })
            .catch((error) => {
              console.error(error);
              // TODO add error alert
              return Promise.reject(error);
            });
        }
        else if (!isEmergency2ndJourney && ((status === '3' || status === 'Planning In Progress') || (status === '3' && (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true)))) {
          // Emergency 1st Journey on status 3
          dispatch(changeStatusReasonForEditCrqId({
            crqId,
            statusReason: null,
          }));
          dispatch(updateEditCrqWithId(crqId, statusTransition))
            // .then(() => {
            //   if (ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) {
            //     dispatch(flAddApproverGroupsToCrq(network, crqId))
            //       .then(() => {
            //         console.log('1stupsinner check0 EMGC vine update new>>>');
            //         const NewstatusTransition = getFowardTransition({ currentStatus: '5', formData });
            //         dispatch(updateEditCrqWithId(crqId, NewstatusTransition));
            //       });
            //   }
            // })
            .then(() => {
              dispatch(clearEditSectionsRead(crqId));
              // let NewstatusTransition = statusTransition;
              // if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true)) {
              //   NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
              // }
              const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                network,
                crqId,
                transitionId: statusTransition.id,
              });
              ownProps.history.push(successPath);
            })
            .catch((error) => {
              console.error(error);
              // TODO add error alert
            });
        }
        else {
          // Emergency 1st Journey----
          // Emergency 1st Journey on status 4
          const statusTransitionEmergency = getBackwardTransition({ currentStatus: '3' });
          const selectedReasonEmergency = getDefaultCancelationReasonEmergency(network);
          dispatch(updateEditCrqWithId(crqId, statusTransition))
          .then((response) => {
            if (response.success === true) {
              dispatch(updateEditCrqWithId(crqId, statusTransitionEmergency, selectedReasonEmergency))
              .then(() => {
                const statusTransitionPostponeEmergency = getBackwardTransition({ currentStatus: '4', isEmergency });
                const selectedReasonPostponeEmergency = network === 'fixed' ? '30300' : 'PostponedCRQ';
                dispatch(updateEditCrqWithId(crqId, statusTransitionPostponeEmergency, selectedReasonPostponeEmergency))
                  .then(() => {
                    dispatch(clearEditSectionsRead(crqId));
                    dispatch(clearRelatedCoordinatorID());
                  })
                  .then(() => {
                    dispatch(clearEditSectionsRead(crqId));
                    // let NewstatusTransition = statusTransition;
                    // if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true)) {
                    //   NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
                    // }
                    // const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
                    //   network,
                    //   crqId,
                    //   transitionId: NewstatusTransition.id,
                    // });
                    // ownProps.history.push(successPath);
                  })
                  .catch((error) => {
                    console.error(error);
                    // TODO add error alert
                  });
              })
              .catch((error) => {
                console.error(error);
                return Promise.reject(error);
              });
            }
          })
          .catch((error) => {
            console.error(error);
            return Promise.reject(error);
          });
          // return null;
        }
      }
      else {
        // For all submit call *************************************
        dispatch(changeStatusReasonForEditCrqId({
          crqId,
          statusReason: (status === '3') ? null : statusReason,
        }));
        dispatch(updateEditCrqWithId(crqId, statusTransition))
          .then(() => {
            if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) && isEmergency) {
              dispatch(flAddApproverGroupsToCrq(network, crqId))
                .then(() => {
                  const NewstatusTransition = getFowardTransition({ currentStatus: '4', formData, isEmergency });
                  dispatch(updateEditCrqWithId(crqId, NewstatusTransition));
                });
            }
            if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) && !isEmergency) {
              dispatch(flAddApproverGroupsToCrq(network, crqId))
                .then(() => {
                  const NewstatusTransition = getFowardTransition({ currentStatus: '5', formData, isEmergency });
                  dispatch(updateEditCrqWithId(crqId, NewstatusTransition));
                });
            }
          })
          .then(() => {
            dispatch(clearEditSectionsRead(crqId));
            let NewstatusTransition = statusTransition;
            if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true) && isEmergency) {
              NewstatusTransition = CRQ_STATUS_TRANSITIONS.submitToPeerReview;
            }
            if ((ownProps.otherLineOperator === 'Yes' || isOlaCrq === true) || (network === 'mobile' && hasReferenceCRQ() === true) && !isEmergency) {
              NewstatusTransition = CRQ_STATUS_TRANSITIONS.oloSubmitToApproval;
            }
            const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
              network,
              crqId,
              transitionId: NewstatusTransition.id,
            });
            ownProps.history.push(successPath);
          })
          .catch((error) => {
            console.error(error);
            // TODO add error alert
          });
      }
    }
    return null;
  },
  flAddApproverAPI: (params) => dispatch(flAddApproverGroupsToCrq(params)),
});

const ViewCrqNav = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewCrqNavDisplay));


export { ViewCrqNav };
